/**
 * Passed props:
 * -> relationId
 * -> relationType
 * e.g. <Documents relationId="51" relationType="repairTickets"/>
 */

import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { APIROOT } from '../../Helpers/configs';
import { converDateWithTime } from '../..//Helpers/dateHelpers';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

export default function Upload(props) {
  //Set States
  const [documentList, setDocumentList] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const [file, setFile] = useState({ selectedfile: {} });
  const [updateCount, setUpdateCount] = useState(1);

  //Get relationID and type from props
  const relationId = props.relationId;
  const relationType = props.relationType;
  // const relationType = props.relationType;

  //Update file list in sstate
  const updateFile = (event) => {
    // console.log(event.target.files);
    setFile({ selectedfile: event.target.files });
  };

  //Upload files
  const UploadFile = () => {
    const formdata = new FormData();
    formdata.append('relation_id', relationId);
    formdata.append('type', relationType);

    for (let i = 0; i < file.selectedfile.length; i++) {
      formdata.append(`FILE_${i}`, file.selectedfile[i]);
    }

    let headers = {
      'x-api-key': localStorage.getItem('JWT_Key'),
    };

    const request = new Request(`${APIROOT}/api/documents`, {
      method: 'POST',
      headers: headers,
      body: formdata,
    });
    fetch(request)
      .then((data) => {
        if (data.status === 200) {
          return data.text();
        } else {
          throw new Error(`Invalid Response`);
        }
      })
      .then((data) => {
        // console.log(`Response: ${data}`); //TODO -> parse this and handle error
        setUpdateCount((i) => i + 1);
        setFile({ selectedfile: {} });
      })
      .catch((error) => {
        setUpdateCount((i) => i + 1);
        setFile({ selectedfile: {} });
      });
  };

  //Get List of all documents attached to relationtype with id
  const getList = () => {
    let headers = {
      'x-api-key': localStorage.getItem('JWT_Key'),
    };
    let body = {
      pagereq: {
        filter: {
          fullfilter: [
            {
              field: 'relation_type',
              search: String(relationType),
              strict: true,
            },
            {
              field: 'relation_id',
              search: String(relationId),
              strict: true,
            },
          ],
        },
      },
    };
    const request = new Request(`${APIROOT}/api/documents`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body),
    });
    fetch(request)
      .then((data) => {
        if (data.status === 200) {
          return data.text();
        } else {
          throw new Error(`Invalid Response`);
        }
      })
      .then((data) => {
        var parsed = JSON.parse(data);

        if (parsed?.success === true) {
          setDocumentList(parsed.data.value);
        } else {
          console.log(`Error: ${parsed?.message}`);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Download File
  const downloadFile = (id) => {
    setDownloading(true);
    let headers = {
      'x-api-key': localStorage.getItem('JWT_Key'),
    };
    let fileName = false;
    const request = new Request(`${APIROOT}/api/documents/${id}`, {
      method: 'POST',
      headers: headers,
    });
    fetch(request)
      .then((data) => {
        for (let pair of data.headers.entries()) {
          if (pair[0] === 'file-name') {
            fileName = pair[1];
            break;
          }
        }

        return data.blob();
      })
      .then((response) => {
        if (fileName !== false) {
          const url = window.URL.createObjectURL(response);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          link.remove();
        } else {
          console.log('No file name header found...');
        }
        setDownloading(false);
      })
      .catch((err) => {
        console.log(err);
        setDownloading(false);
      });
  };
  //Update List
  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCount]);

  return (
    <>
      <div style={{ marginTop: '10px' }}>
        <Button variant='contained' component='label'>
          Select Files{' '}
          <input hidden multiple type='file' onChange={updateFile} />
        </Button>

        <div style={{ margin: '20px' }}>
          <table>
            <tbody>
              {Object.keys(file.selectedfile).map((key, index) => {
                return (
                  <tr key={index}>
                    <td>{file.selectedfile[key].name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Button
          variant='contained'
          style={{
            display:
              typeof file.selectedfile.length !== 'undefined' &&
              file.selectedfile.length > 0
                ? 'block'
                : 'none',
          }}
          onClick={UploadFile}
        >
          Save
        </Button>
      </div>
      <div style={{ marginTop: '10px' }}>
        <TableContainer>
          <Table sx={{ minWidth: 650 }} size='small' aria-label='a dense table'>
            <TableHead>
              <TableRow>
                <TableCell>File Name</TableCell>
                <TableCell>Date and Time Created</TableCell>
                <TableCell align='right'>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {documentList.map((entry) => (
                <TableRow
                  key={entry.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component='th' scope='row'>
                    {entry?.file_name}
                  </TableCell>
                  {/* <TableCell>{entry?.created.substring(0, 19)}</TableCell> */}
                  <TableCell>{converDateWithTime(entry?.created)}</TableCell>
                  <TableCell align='right'>
                    {' '}
                    <Button
                      disabled={downloading}
                      onClick={() => {
                        downloadFile(entry.id);
                      }}
                    >
                      Download
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* <table>
          <thead>
            <tr>
              <th>File Name:</th>
              <th>Created:</th>
              <th>Actions:</th>
            </tr>
          </thead>
          <tbody>
            {documentList.map((entry) => {
              return (
                <tr key={entry.id}>
                  <td>{entry?.file_name}</td>
                  <td>{entry?.created.substring(0, 19)}</td>
                  <td>
                    <Button
                      disabled={downloading}
                      onClick={() => {
                        downloadFile(entry.id);
                      }}
                    >
                      Download
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table> */}
      </div>
    </>
  );
}
